import { Box, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { generateClient } from 'aws-amplify/api';
import { Schema } from '../../../amplify/data/resource';
import Main from './variants/admin/Main';

// @ts-ignore
type Agent = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const Admin = () => {
  const theme = useTheme();

  const [agent, setAgent] = useState<Agent | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <Box>
      <Main />
    </Box>
  );
};

export default Admin;
